import { EArea } from "./constants";
export var DEFAULT_TEXTS = {
  paymentLegacy: false,
  loginUrl: '/auth/login',
  emailPopup: {
    emailInput: {
      label: 'почта',
      placeholder: 'example@mail.ru'
    },
    buttonText: 'подтвердить',
    title: 'введите почту для отправки чека'
  },
  statusScreens: {
    paymentSuccess: {
      title: '+ {{sum}} ₽',
      description: 'через пару минут на балансе'
    },
    paymentError: {
      title: 'не получилось пополнить баланс',
      description: 'технические неполадки'
    },
    smsCodeMaxCheckError: {
      title: 'код не подошёл слишком много раз',
      description: 'можно запросить новый'
    },
    smsCodeMaxSendError: {
      title: 'попытки закончились',
      description: 'новые появятся через 30 мин'
    },
    technicalError: {
      title: 'что-то пошло не по плану',
      description: 'иногда такое случается — попробуйте ещё раз позже'
    },
    paymentProcess: {
      title: 'платёж обрабатывается',
      description: 'по рузельтатам пришлём смс'
    },
    smsCodeExpired: {
      title: 'время действия кода истекло',
      description: 'нужно запросить новый'
    },
    buttons: {
      returnButtonText: 'вернуться на сайт',
      anotherPaymentButtonText: 'пополнить иначе',
      retryButtonText: 'попробовать ещё раз',
      createAutopayButtonText: 'превратить в автоплатёж',
      updateAutopayButton: 'изменить автоплатёж',
      resendSmsCode: 'отправить ещё раз'
    }
  },
  paymentSection: {
    title: 'другие',
    unauthorizedTitle: 'способы оплаты'
  },
  quickPaymentSection: {
    title: 'быстрые платежи'
  },
  sbpPopup: {
    bankList: {
      title: 'выбиерите банк',
      subtitle: ''
    },
    qr: {
      title: 'оплата по СБП',
      subtitle: 'отсканируйте QR-код камерой телефона или в приложении банка',
      alt: 'картинка с QR кодом',
      buttonText: 'понятно'
    },
    request: {
      pollInterval: 10000,
      timeout: 60000
    }
  },
  sberPayPopup: {
    backButtonText: 'назад',
    phoneInput: {
      label: 'номер телефона',
      placeholder: 'номер телефона'
    },
    title: 'вход в SberPay',
    subtitle: 'отправим пуш-уведомление в приложение СберБанк или SMS на номер, чтобы убедиться, что это вы',
    agreement: '',
    captcha: {
      errorMessage: 'неверный код',
      label: 'символы с картинки',
      placeholder: 'символы с картинки',
      subtitle: 'отправьте символы с картинки, чтобы подтвердить, что нет :)',
      title: 'вы робот?',
      buttonText: 'отправить'
    },
    buttonText: 'отправить подтверждение',
    request: {}
  },
  smsPopup: {
    debounce: 1000,
    buttonProps: {
      text: 'получить новый код',
      countdownText: 'новый сможем отправить через {{time}}',
      countdown: 60
    },
    length: 4,
    incorrectCodeText: 'неверный код',
    title: 'код подтверждения',
    subtitle: 'пятизначный код отправили в смс на номер {{phoneNumber}}'
  },
  submitButtonTexts: {
    card: 'оплатить новой картой',
    default: 'оплатить',
    sberpay: 'оплатить с помощью СберПей',
    fps: 'оплатить по СБП',
    savedCards: 'оплатить картой'
  },
  changePaymentButton: {
    buttonText: 'изменить',
    title: 'способ оплаты'
  },
  offer: {
    text: 'нажимая «оплатить», вы соглашаетесь с {{agreement}} и {{limits}}',
    vars: {
      agreement: {
        href: 'https://static.beeline.ru/upload/WebWidgetsPay/contents/344/6244-oferta.pdf',
        children: 'договором оферты'
      },
      limits: {
        href: 'https://static.beeline.ru/upload/WebWidgetsPay/contents/344/4248-limit.pdf',
        children: 'лимитами'
      }
    }
  },
  cardLogos: [{
    alt: 'Mir',
    id: 'mir',
    src: 'https://static.beeline.ru/upload/images/b2c/logos/payment-systems/logo-mir.svg'
  }, {
    alt: 'Visa',
    id: 'visa',
    src: 'https://static.beeline.ru/upload/images/b2c/logos/payment-systems/logo-visa.svg'
  }, {
    alt: 'MasterCard',
    id: 'mastercard',
    src: 'https://static.beeline.ru/upload/images/b2c/logos/payment-systems/logo-mc.svg'
  }],
  header: {
    login: 'войти',
    size: 'size3-m',
    tag: 'h2',
    title: 'Пополнение счёта'
  },
  paymentMethods: {
    newCard: [EArea.AccountDashboard, EArea.Authorized, EArea.Unauthorized],
    sbp: [EArea.AccountDashboard, EArea.Authorized, EArea.Unauthorized],
    sbpBinding: [EArea.AccountDashboard, EArea.Authorized, EArea.Unauthorized],
    boundCards: [EArea.AccountDashboard, EArea.Authorized, EArea.Unauthorized],
    sberPay: [EArea.AccountDashboard, EArea.Authorized, EArea.Unauthorized],
    sberPayBinding: [EArea.AccountDashboard, EArea.Authorized, EArea.Unauthorized]
  },
  paymentMethodsOptions: {
    boundCards: {
      cardNumber: '',
      id: 'boundCards',
      sort: 3,
      title: 'картой'
    },
    newCard: {
      cardNumber: '',
      id: 'newCard',
      sort: 3,
      title: 'новой картой'
    },
    sbp: {
      cardNumber: '',
      id: 'sbp',
      sort: 2,
      title: 'СБП'
    },
    sberPay: {
      cardNumber: '',
      id: 'sberPay',
      sort: 2,
      title: 'SberPay'
    }
  },
  phoneInput: {
    label: 'номер телефона или договора',
    placeholder: 'номер телефона или договора',
    shouldSkipValidation: false
  },
  phoneInputErrorTexts: {
    beeline: 'номер не билайн',
    empty: 'не может быть пустым',
    incomplete: 'введите номер полностью',
    default: 'ошибка'
  },
  sumInput: {
    label: 'сумма пополнения',
    maxLength: 20,
    placeholder: '{{min}}-{{max}} ₽',
    postFix: '₽',
    priceTags: [100, 250, 500, 1000]
  },
  sumInputErrorTexts: {
    empty: 'введите сумму',
    outOfBounds: 'неверная сумма',
    min: 'минимальная сумма пополнения {{min}} ₽',
    max: 'максимальная сумма пополнения {{max}} ₽'
  },
  widgetPayUrl: '',
  paymentRBS: true,
  paymentParams: {
    amount: {
      min: 100,
      max: 15000000
    }
  },
  requestSettings: {
    default: {
      delay: 2000,
      interval: 2000,
      timeout: 60000
    }
  },
  profileUrl: '/customers/products/elk/'
};